import type {
  AxiosRequestConfig,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

interface OTPLoginRequestBody {
  code: string;
  phone_number: string;
}

export interface OTPLoginResponse {
  customer_id: string;
  access_token: string;
}

export const OTPLoginFn = async (
  body: OTPLoginRequestBody,
  config: AxiosRequestConfig = {}
): Promise<OTPLoginResponse> => {
  // Sử dụng Next.js API route làm proxy để bảo vệ endpoint
  const response = await fetch('/api/auth/verify-otp', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      error: 'NETWORK_ERROR',
      message: 'Không thể kết nối đến server',
    }));

    // Tạo error object tương thích với axios format
    const error: any = new Error(errorData.message || 'Failed to verify OTP');
    error.response = {
      data: {
        error: errorData.error,
        title: errorData.error,
        message: errorData.message,
        blockedUntil: errorData.blockedUntil,
      },
      status: response.status,
    };
    throw error;
  }

  return response.json();
};

export const useLoginOTP = (
  opts?: UseMutationOptions<
    OTPLoginResponse,
    DefaultQueryError,
    OTPLoginRequestBody
  >
) => {
  return useMutation<OTPLoginResponse, DefaultQueryError, OTPLoginRequestBody>({
    mutationFn: OTPLoginFn,
    ...opts,
  });
};
